import { render, staticRenderFns } from "./provider-list-item.vue?vue&type=template&id=6e4c576e&scoped=true"
import script from "./provider-list-item.vue?vue&type=script&lang=js"
export * from "./provider-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4c576e",
  null
  
)

export default component.exports